"use strict";
exports.__esModule = true;
exports.STATUSES_POSSIBLE_AUTH_FAILURE = exports.STATUS_OK = exports.CONTENT_TYPE_JSON = exports.DEFAULT_BASE_URL = exports.DEFAULT_BASE_URL_STAGING = void 0;
exports.DEFAULT_BASE_URL_STAGING = "https://staging-us-central1-gcp.api.snapchat.com/web-analytics/web";
exports.DEFAULT_BASE_URL = "https://us-central1-gcp.api.snapchat.com/web-analytics/web";
exports.CONTENT_TYPE_JSON = "application/json; charset=UTF-8";
exports.STATUS_OK = 200;
exports.STATUSES_POSSIBLE_AUTH_FAILURE = [400, 401, 403];
//# sourceMappingURL=constants.js.map